// VITE_MIGRATION: explicit deps on namespace so glob-hoisted tool files
// that transitively import this module see Sparkle.PageBuilder ready.
import "./namespace.js";

(function () {
  /*******************************
   * Helper functions.
   */

  //event emitter
  var event = Backbone.Events;

  /**
   * A basic assert function, throws error with message if the assertion is false
   * @name assert
   * @param {boolean} assertion - A boolean being asserted
   * @param {string} message - A message to display if assertion is false
   **/
  function assert(assertion, message) {
    if (!assertion) {
      throw new Error(message);
    }
  }

  /**
   * Creates a deep copy of an object, so any changes made to the
   * new object, no matter what level of nesting, does not affect
   * the original object.
   * @param {object} original - The object to be cloned.
   **/
  function deepCopy(original) {
    if (typeof original === "undefined") {
      return undefined;
    }

    if (original === null) {
      return null;
    }

    //JSON stringify does not go into prototype properties,
    if (!jQuery.isArray(original) && typeof original === "object") {
      original = flatten(original);
    }
    // need to watch out for dates, which won't work with this.
    return JSON.parse(JSON.stringify(original));
  }

  /**
   * If an object has a prototype, deep copy will miss
   * inherited properties. flatten pulls the inherited properties
   * onto an object so they can be copied correctly.
   * @param {object} obj - The object to be flattened.
   */
  function flatten(obj) {
    var flattened = {};
    for (var prop in obj) {
      flattened[prop] = obj[prop];
    }
    return flattened;
  }

  /**
   * The number of columns that a section has is not stored in the data,
   * so we have to retrieve it based on class name.
   * @param {NodeList} classList - classList of the component element.
   **/
  function numColumns(element) {
    return Number(element.getAttribute("data-columns"));
  }

  /**
   * Can't use only Object.create for some objects, especially those
   * created and defined by Quill.
   */
  function inherit(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true,
      },
    });

    Object.setPrototypeOf(subClass, superClass);
  }

  /**
   * given a component, return which keys are powered by a specific tool.
   * e.g. we can't always count on the name of the image attributes being
   * 'image', so we have to check whether the tool for the attribute
   * is the image editor. if it is..
   * @param {string} templateId - Template ID of a component.
   * @param {object} componentDefinitions - Description of all components.
   * @param {string} tool - Tool ID.
   * @returns {array} - List of which attributes are powered by specified tool.
   **/
  function toolKeysForComponent(config, tool) {
    // we'll use this to keep track of which attributes of the component are
    // powered by the specified tool.
    var toolKeys = [];

    // for each of the keys of the current component..
    var context = config["attributes"];
    for (var key in context) {
      var value = context[key];

      // if this key is managed by the specified tool.
      if (value["tool"] === tool) {
        // add it to the return value.
        toolKeys.push(key);
      }
    }

    return toolKeys;
  }

  // given an array of numbers, return the sum of them.
  function sum(array) {
    if (array.length > 0) {
      array.reduce(function (a, b) {
        return a + b;
      });
    } else {
      return 0;
    }
  }

  //export
  Sparkle.PageBuilder.Helpers = {
    sum: sum,
    numColumns: numColumns,
    flatten: flatten,
    deepCopy: deepCopy,
    assert: assert,
    toolKeysForComponent: toolKeysForComponent,
    Event: event,
    inherit: inherit,
  };
})(); //end module
